// 转介绍模块多语言配置
export const turnToIntroduce = {
  'zh-CN': {
    // 成员信息
    memberName: '成员名称',
    partnerCount: '下级合作伙伴数',
    totalReferralCustomers: '转介绍客户总数',
    successfulCustomers: '已成交客户数',
    totalTransactionAmount: '成交总金额',
    promotionRewardExpense: '推广赏金支出金额',
    
    // 邀请码和二维码
    memberInvitationCode: '成员邀请码',
    noInvitationCode: '暂无',
    invitationQRCode: '邀请二维码',
    clickToView: '点击查看',
    
    // 搜索条件
    partnerName: '合作伙伴名称',
    pleaseEnterPartnerName: '请输入合作伙伴名称',
    phoneNumber: '手机号',
    pleaseEnterPhoneNumber: '请输入手机号',
    startDate: '开始日期',
    endDate: '结束日期',
    search: '查询',
    export: '导出',
    
    // 表格列标题
    partnerName: '合作伙伴名称',
    phoneNumber: '手机号',
    becomePartnerTime: '成为合作伙伴时间',
    totalReferralCustomers: '转介绍客户总数',
    unfollowedCustomers: '未跟进客户数',
    followedCustomers: '已跟进客户数',
    successfulCustomers: '已成交客户数',
    manualTransactionAmount: '录入成交金额',
    mallTransactionAmount: '商城交易金额',
    totalPromotionReward: '累计获得推广赏金',
    withdrawableReward: '可提现赏金',
    withdrawingReward: '提现中赏金',
    operation: '操作',
    
    // 操作按钮
    releaseRelationship: '解除关系',
    details: '详情',
    
    // 客户信息
    customerName: '介绍客户名称',
    pleaseEnterCustomerName: '请输入客户名称',
    wechatAccount: '微信号',
    introductionTime: '介绍时间',
    source: '来源',
    status: '状态',
    directLead: '直接线索',
    sharedBusinessCard: '分享名片',
    unfollowed: '未跟进',
    following: '跟进中',
    successful: '已成交',
    
    // 筛选选项
    all: '全部',
    unfollowed: '未被跟进',
    following: '跟进中',
    successful: '已成交',
    
    // 对话框
    invitationQRCode: '邀请二维码',
    releaseRelationshipTitle: '解除关系',
    releaseRelationshipConfirm: '解除关系后，所有转介绍客户的内容都将清除，且不可恢复，是否继续',
    confirm: '确定',
    cancel: '取消',
    
    // 消息提示
    copySuccess: '复制成功！',
    releaseSuccess: '成功取消',
    operationCancelled: '已取消',
    customerNotStored: '此客户尚未被成员存为客户，无法查看',
    
    // 通用
    yuan: '港元',
    partnerName: '合作伙伴名称',
    customerCount: '客户数',
    transactionAmount: '成交金额',
    promotionReward: '推广赏金',
    
    // 提现相关
    withdrawalSettings: '提现设置',
    minimumWithdrawalStandard: '最低提现标准',
    minimumWithdrawalTip: '港元',
    paymentMethodSettings: '支付方式设置',
    autoPaymentSettingsTip: '开启后自动到账',
    save: '保存',
    withdrawalList: '提现列表',
    withdrawalTime: '提现时间',
    serialNumber: '序号',
    receiptAccount: '收款账户',
    withdrawalAmountYuan: '提现金额(港元)',
    applicationTime: '申请时间',
    waitingForPayment: '等待付款',
    paymentSuccessful: '付款成功',
    approvedPendingPayment: '已批准待付款',
    approvalRejectionTime: '审批拒绝时间',
    remarks: '备注',
    openRejectBox: '请输入拒绝原因',
    rejectReasonRequired: '拒绝原因不能为空',
    cancelInputTip: '取消输入',
    operationIrreversible: '此操作不可逆，是否继续？',
    withdrawal: '提现',
    confirmContinue: '确认继续',
    rejected: "拒绝",
    companyName: "公司名称",
    reject: '驳回',
  },
  'zh-TW': {
    // 成員信息
    memberName: '成員名稱',
    partnerCount: '下級合作夥伴數',
    totalReferralCustomers: '轉介紹客戶總數',
    successfulCustomers: '已成交客戶數',
    totalTransactionAmount: '成交總金額',
    promotionRewardExpense: '推廣賞金支出金額',
    
    // 邀請碼和二維碼
    memberInvitationCode: '成員邀請碼',
    noInvitationCode: '暫無',
    invitationQRCode: '邀請二維碼',
    clickToView: '點擊查看',
    
    // 搜索條件
    partnerName: '合作夥伴名稱',
    pleaseEnterPartnerName: '請輸入合作夥伴名稱',
    phoneNumber: '手機號',
    pleaseEnterPhoneNumber: '請輸入手機號',
    startDate: '開始日期',
    endDate: '結束日期',
    search: '查詢',
    export: '導出',
    
    // 表格列標題
    partnerName: '合作夥伴名稱',
    phoneNumber: '手機號',
    becomePartnerTime: '成為合作夥伴時間',
    totalReferralCustomers: '轉介紹客戶總數',
    unfollowedCustomers: '未跟進客戶數',
    followedCustomers: '已跟進客戶數',
    successfulCustomers: '已成交客戶數',
    manualTransactionAmount: '錄入成交金額',
    mallTransactionAmount: '商城交易金額',
    totalPromotionReward: '累計獲得推廣賞金',
    withdrawableReward: '可提現賞金',
    withdrawingReward: '提現中賞金',
    operation: '操作',
    
    // 操作按鈕
    releaseRelationship: '解除關係',
    details: '詳情',
    
    // 客戶信息
    customerName: '介紹客戶名稱',
    pleaseEnterCustomerName: '請輸入客戶名稱',
    wechatAccount: '微信號',
    introductionTime: '介紹時間',
    source: '來源',
    status: '狀態',
    directLead: '直接線索',
    sharedBusinessCard: '分享名片',
    unfollowed: '未跟進',
    following: '跟進中',
    successful: '已成交',
    
    // 篩選選項
    all: '全部',
    unfollowed: '未被跟進',
    following: '跟進中',
    successful: '已成交',
    
    // 對話框
    invitationQRCode: '邀請二維碼',
    releaseRelationshipTitle: '解除關係',
    releaseRelationshipConfirm: '解除關係後，所有轉介紹客戶的內容都將清除，且不可恢復，是否繼續',
    confirm: '確定',
    cancel: '取消',
    
    // 消息提示
    copySuccess: '複製成功！',
    releaseSuccess: '成功取消',
    operationCancelled: '已取消',
    customerNotStored: '此客戶尚未被成員存為客戶，無法查看',
    
    // 通用
    yuan: '港元',
    partnerName: '合作夥伴名稱',
    customerCount: '客戶數',
    transactionAmount: '成交金額',
    promotionReward: '推廣賞金',
    
    // 提现相关
    withdrawalSettings: '提現設置',
    minimumWithdrawalStandard: '最低提現標準',
    minimumWithdrawalTip: '港元',
    paymentMethodSettings: '支付方式設置',
    autoPaymentSettingsTip: '開啟後自動到賬',
    save: '保存',
    withdrawalList: '提現列表',
    withdrawalTime: '提現時間',
    serialNumber: '序號',
    receiptAccount: '收款賬戶',
    withdrawalAmountYuan: '提現金額(港元)',
    applicationTime: '申請時間',
    waitingForPayment: '等待付款',
    paymentSuccessful: '付款成功',
    approvedPendingPayment: '已批准待付款',
    approvalRejectionTime: '審批拒絕時間',
    remarks: '備註',
    openRejectBox: '請輸入拒絕原因',
    rejectReasonRequired: '拒絕原因不能為空',
    cancelInputTip: '取消輸入',
    operationIrreversible: '此操作不可逆，是否繼續？',
    withdrawal: '提現',
    confirmContinue: '確認繼續',
    rejected: '拒絕',
    companyName: "公司名稱",
    reject: '駁回',

  },
  'en': {
    // Member Information
    memberName: 'Member Name',
    partnerCount: 'Subordinate Partner Count',
    totalReferralCustomers: 'Total Referral Customers',
    successfulCustomers: 'Successful Customers',
    totalTransactionAmount: 'Total Transaction Amount',
    promotionRewardExpense: 'Promotion Reward Expense',
    
    // Invitation Code and QR Code
    memberInvitationCode: 'Member Invitation Code',
    noInvitationCode: 'None',
    invitationQRCode: 'Invitation QR Code',
    clickToView: 'Click to View',
    
    // Search Conditions
    partnerName: 'Partner Name',
    pleaseEnterPartnerName: 'Please enter partner name',
    phoneNumber: 'Phone Number',
    pleaseEnterPhoneNumber: 'Please enter phone number',
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    export: 'Export',
    
    // Table Column Headers
    partnerName: 'Partner Name',
    phoneNumber: 'Phone Number',
    becomePartnerTime: 'Become Partner Time',
    totalReferralCustomers: 'Total Referral Customers',
    unfollowedCustomers: 'Unfollowed Customers',
    followedCustomers: 'Followed Customers',
    successfulCustomers: 'Successful Customers',
    manualTransactionAmount: 'Manual Transaction Amount',
    mallTransactionAmount: 'Mall Transaction Amount',
    totalPromotionReward: 'Total Promotion Reward',
    withdrawableReward: 'Withdrawable Reward',
    withdrawingReward: 'Withdrawing Reward',
    operation: 'Operation',
    
    // Action Buttons
    releaseRelationship: 'Release Relationship',
    details: 'Details',
    
    // Customer Information
    customerName: 'Customer Name',
    pleaseEnterCustomerName: 'Please enter customer name',
    wechatAccount: 'WeChat Account',
    introductionTime: 'Introduction Time',
    source: 'Source',
    status: 'Status',
    directLead: 'Direct Lead',
    sharedBusinessCard: 'Shared Business Card',
    unfollowed: 'Unfollowed',
    following: 'Following',
    successful: 'Successful',
    
    // Filter Options
    all: 'All',
    unfollowed: 'Unfollowed',
    following: 'Following',
    successful: 'Successful',
    
    // Dialogs
    invitationQRCode: 'Invitation QR Code',
    releaseRelationshipTitle: 'Release Relationship',
    releaseRelationshipConfirm: 'After releasing the relationship, all referral customer content will be cleared and cannot be restored. Do you want to continue?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    
    // Messages
    copySuccess: 'Copy successful!',
    releaseSuccess: 'Successfully cancelled',
    operationCancelled: 'Operation cancelled',
    customerNotStored: 'This customer has not been stored as a customer by the member and cannot be viewed',
    
    // Common
    yuan: 'HK$',
    partnerName: 'Partner Name',
    customerCount: 'Customer Count',
    transactionAmount: 'Transaction Amount',
    promotionReward: 'Promotion Reward',
    
    // Withdrawal Related
    withdrawalSettings: 'Withdrawal Settings',
    minimumWithdrawalStandard: 'Minimum Withdrawal Standard',
    minimumWithdrawalTip: 'HK$',
    paymentMethodSettings: 'Payment Method Settings',
    autoPaymentSettingsTip: 'Auto-arrival after enabled',
    save: 'Save',
    withdrawalList: 'Withdrawal List',
    withdrawalTime: 'Withdrawal Time',
    serialNumber: 'Serial Number',
    receiptAccount: 'Receipt Account',
    withdrawalAmountYuan: 'Withdrawal Amount (Yuan)',
    applicationTime: 'Application Time',
    waitingForPayment: 'Waiting for Payment',
    paymentSuccessful: 'Payment Successful',
    approvedPendingPayment: 'Approved Pending Payment',
    approvalRejectionTime: 'Approval/Rejection Time',
    remarks: 'Remarks',
    openRejectBox: 'Please enter rejection reason',
    rejectReasonRequired: 'Rejection reason cannot be empty',
    cancelInputTip: 'Input cancelled',
    operationIrreversible: 'This operation is irreversible. Do you want to continue?',
    withdrawal: 'Withdrawal',
    confirmContinue: 'Confirm Continue',
    rejected: 'Rejected',
    companyName: "Company Name",
    reject: 'reject',
  }
}; 